import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SettingsDropdown } from 'src/components'
import { LockShieldIcon } from 'src/assets/icons'
import { TwoFAModal } from '../../two-fa-modal'
import { ETranslationNs } from 'src/types'

const TwoFAButton = () => {
  const [t] = useTranslation(ETranslationNs.UserProfile)
  const [open, setOpen] = useState(false)

  const handleClose = () => setOpen(false)
  const handleChangePassword = () => setOpen(true)

  return (
    <>
      <SettingsDropdown
        onButtonClick={handleChangePassword}
        text={t('user-profile-two-step-button.v', { ns: ETranslationNs.UserProfile })}
        icon={<LockShieldIcon />}
      />
      <TwoFAModal open={open} onClose={handleClose} />
    </>
  )
}

export { TwoFAButton }
